export default "__VITE_ASSET__d4a6351c__"